import React from "react";
import uniqueId from "lodash/uniqueId";
import PropTypes from "prop-types";

import { AddButton } from "../../../../components/Buttons/AddButton";

export const ArrayAddButton = ({
  arrayHelpers,
  dataArray,
  addedItem,
  limit,
  requiredFields,
  noUniqueID = false,
  ...props
}) => {
  const checkIsAddButtonDisabled = () => {
    if (!dataArray.length) {
      return false;
    }
    const lastAddedItem = dataArray[dataArray.length - 1];
    return dataArray.length === limit || requiredFields.some(item => lastAddedItem[item] === "");
  };

  return (
    <AddButton
      onClick={() =>
        noUniqueID
          ? arrayHelpers.insert(dataArray.length, addedItem)
          : arrayHelpers.insert(dataArray.length, { ...addedItem, id: uniqueId() })
      }
      disabled={checkIsAddButtonDisabled()}
      showIcon={false}
      {...props}
    />
  );
};

ArrayAddButton.propTypes = {
  /**
   * Array helpers from Formik's FieldArray component
   */
  arrayHelpers: PropTypes.shape({
    insert: PropTypes.func.isRequired,
    remove: PropTypes.func,
    push: PropTypes.func,
    pop: PropTypes.func
  }).isRequired,

  /**
   * Array of data items to be manipulated
   */
  dataArray: PropTypes.array.isRequired,

  /**
   * Item template to be added to the array
   */
  addedItem: PropTypes.object.isRequired,

  /**
   * Maximum number of items allowed in the array
   */
  limit: PropTypes.number,

  /**
   * Fields that must be filled before adding another item
   */
  requiredFields: PropTypes.arrayOf(PropTypes.string),

  /**
   * Flag to determine if a unique ID should be generated for new items
   */
  noUniqueID: PropTypes.bool,

  /**
   * Additional props to be passed to the AddButton component
   */
  sx: PropTypes.object,

  /**
   * Button text
   */
  title: PropTypes.string
};
